export const SET_QR_CODE_CONFIG = 'SET_QR_CODE_CONFIG'
export const SET_MENU_CONFIG = 'SET_MENU_CONFIG'
